module.exports = __webpack_public_path__ + "img/logo-wel-fit.53a76f24.png";